module.exports = __webpack_public_path__ + "static/WEDDING E&M-66-f69b9757b5c2eb9809d483aa06d84de8.jpg";